/// <amd-module name="Repos/Views/Settings/Options/RestClient/Settings" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   tfs\web\extensions\code\vss-code-web\repos\views\settings\options\genclient.json
 */

import { IVssPageContext, IVssRestClient, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";

export interface ISettingsRestClient extends IVssRestClient {
    /**
     * Get all setting entries for the given named scope
     * 
     * @param userScope - User-Scope at which to get the value. Should be "me" for the current user or "host" for all users.
     * @param scopeName - Scope at which to get the setting for (e.g. "project" or "team")
     * @param scopeValue - Value of the scope (e.g. the project or team id)
     * @param key - Optional key under which to filter all the entries
     */
    getEntriesForScope(userScope: string, scopeName: string, scopeValue: string, key?: string): Promise<{ [key: string] : any; }>;
    /**
     * Set the specified entries for the given named scope
     * 
     * @param entries - The entries to set
     * @param userScope - User-Scope at which to set the values. Should be "me" for the current user or "host" for all users.
     * @param scopeName - Scope at which to set the settings on (e.g. "project" or "team")
     * @param scopeValue - Value of the scope (e.g. the project or team id)
     */
    setEntriesForScope(entries: { [key: string] : any; }, userScope: string, scopeName: string, scopeValue: string): Promise<void>;
}

class SettingsRestClient extends RestClientBase implements ISettingsRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * Get all setting entries for the given named scope
     * 
     * @param userScope - User-Scope at which to get the value. Should be "me" for the current user or "host" for all users.
     * @param scopeName - Scope at which to get the setting for (e.g. "project" or "team")
     * @param scopeValue - Value of the scope (e.g. the project or team id)
     * @param key - Optional key under which to filter all the entries
     */
    public async getEntriesForScope(
        userScope: string,
        scopeName: string,
        scopeValue: string,
        key?: string
        ): Promise<{ [key: string] : any; }> {

        return this.beginRequest<{ [key: string] : any; }>({
            apiVersion: "5.0-preview.1",
            routeTemplate: "_apis/Settings/{scopeName}/{scopeValue}/Entries/{userScope}/{*key}",
            routeValues: {
                userScope: userScope,
                scopeName: scopeName,
                scopeValue: scopeValue,
                key: key
            }
        });
    }

    /**
     * Set the specified entries for the given named scope
     * 
     * @param entries - The entries to set
     * @param userScope - User-Scope at which to set the values. Should be "me" for the current user or "host" for all users.
     * @param scopeName - Scope at which to set the settings on (e.g. "project" or "team")
     * @param scopeValue - Value of the scope (e.g. the project or team id)
     */
    public async setEntriesForScope(
        entries: { [key: string] : any; },
        userScope: string,
        scopeName: string,
        scopeValue: string
        ): Promise<void> {

        return this.beginRequest<void>({
            apiVersion: "5.0-preview.1",
            method: "PATCH",
            routeTemplate: "_apis/Settings/{scopeName}/{scopeValue}/Entries/{userScope}/{*key}",
            routeValues: {
                userScope: userScope,
                scopeName: scopeName,
                scopeValue: scopeValue
            },
            body: entries
        });
    }

}

export const SettingsClientName = "Repos.Settings.Options.Settings.ISettingsRestClient";

export function getSettingsClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): ISettingsRestClient {
    return pageContext.getRestClient<ISettingsRestClient>(SettingsClientName, options);
}

RestClients.add(SettingsClientName, { 
    factory: SettingsRestClient,
    options: {
        serviceInstanceType: "00025394-6065-48ca-87d9-7f5672854ef7"
    }
});
